export const REGEX = {
	/**
	 * Allows empty string.
	 * Disallows special characters, Cyrillic letters, and invalid replacement chars.
	 */
	NO_SPECIAL_CHARS_OR_CYRILLIC:
		'^[^!@#$%^&*()_+=|\\{};><?\u0400-\u04FF\uFFFD]*$',

	/**
	 * Allows empty string.
	 * Disallows special characters and invalid replacement chars.
	 */
	NO_SPECIAL_CHARS: '^[^!@#$%^&*()_+=|\\{};><?\uFFFD]*$',

	/**
	 * Allows a phone number with an optional country code, optional parentheses area code, flexible grouping of digits, optional spaces or hyphens, and 3–4 digit final blocks.
	 */
	PHONE_NUMBER:
		'^(((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?)?$',
	/**
	 * UK mobile/landline: +44 0 followed by exactly 10 digits, with optional spaces or dashes between digits.
	 * Allows empty string (required check handled separately).
	 */
	UK_PHONE_NUMBER: '^(\\+44 0(\\d[\\s\\-]?){9}\\d)?$',

	/**
	 * Allows valid email addresses with either standard or quoted local parts. Supports dots in the local part, special characters like ! # $ % & * + - / = ? ^ _ ` { | } ~, and international Unicode characters. The domain must consist of one or more labels separated by dots, allowing letters, numbers, hyphens, and Unicode characters.
	 */
	EMAIL_ADDRESS:
		"^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+([a-z]+|\\d|-|\\.{0,1}|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])?([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$",
} as const